import { removeNamespace } from '@/utils/helpers'
import FlagService from '@/services/flag.service'
import * as cloneDeep from 'lodash.clonedeep'

export const FLAGS_TYPES = {
  mutations: {
    SET_LOADING: 'flags/SET_LOADING',
    SET_PAGED_FLAGS: 'flags/SET_PAGED_FLAGS',
    SET_TOTAL_FLAGS_COUNT: 'flags/SET_TOTAL_FLAGS_COUNT',
    SET_FLAG_TABLE_OPTIONS: 'flags/SET_FLAG_TABLE_OPTIONS',
    SET_FLAG_SEARCH_OPTIONS: 'flags/SET_FLAG_SEARCH_OPTIONS'
  },
  actions: {
    fetchFlagsPaged: 'flags/fetchFlagsPaged'
  }
}

const _types = removeNamespace('flags', FLAGS_TYPES)

const state = () => ({
  loading: false,
  flagTableOptions: {
    page: 1,
    itemsPerPage: 10
  },
  flagSearchOptions: {
    keyword: ''
  },
  pagedFlags: [],
  totalFlagsCount: 0
})

const getters = {}

const mutations = {
  [_types.mutations.SET_LOADING] (state, bool) {
    state.loading = bool
  },
  [_types.mutations.SET_PAGED_FLAGS] (state, pagedResult) {
    state.pagedFlags = pagedResult
  },
  [_types.mutations.SET_TOTAL_FLAGS_COUNT] (state, count) {
    state.totalFlagsCount = count
  },
  [_types.mutations.SET_FLAG_TABLE_OPTIONS] (state, options) {
    state.flagTableOptions = options
  },
  [_types.mutations.SET_FLAG_SEARCH_OPTIONS] (state, options) {
    state.flagSearchOptions = cloneDeep(options)
  }
}

const actions = {
  [_types.actions.fetchFlagsPaged] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING, true)
    const { itemsPerPage, page } = state.flagTableOptions
    const maxResultCount = itemsPerPage
    const skipCount = (page - 1) * itemsPerPage
    return FlagService.fetchFlagsPaged(skipCount, maxResultCount, state.flagSearchOptions.keyword)
      .then((res) => {
        const { items, totalCount } = res
        commit(_types.mutations.SET_PAGED_FLAGS, items)
        commit(_types.mutations.SET_TOTAL_FLAGS_COUNT, totalCount)
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
